import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { gamersStore } from "../../../Stores/playersStore";
import {
  Button,
  FormControl,
  InputLabel,
  ListSubheader,
  MenuItem,
  Select,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Container } from "react-bootstrap";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { portalStore } from "../../../Stores/portal";
import { useEffect, useRef, useState } from "react";
import PlayerProfile from "../../../Components/Dialog/playerProfile";
const PlayersSub: React.FC = () => {
  const headerRef = useRef(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (headerRef.current) {
      const h = (headerRef.current as unknown as any).offsetHeight as number;
      setHeight(h);
    }
  }, [headerRef]);
  return (
    <Container
      fluid
      style={{
        display: "flex",
        flexFlow: "column",
        overflowY: "hidden",
        height: portalStore.portalHeight,
      }}
    >
      <div
        style={{
          width: "100%",
          display: "flex",
          flexFlow: "row",
          background: "tomato",
        }}
        ref={headerRef}
      >
        {/* <h3 style={{ width: "50%" }}>Players</h3> */}
        {/* <TableFilters /> */}
      </div>
      <div style={{ overflowY: "auto" }}>
        <MainTable />
      </div>
    </Container>
  );
};

const TableFilters: React.FC = () => {
  return (
    <div>
      <FormControl sx={{ m: 1, minWidth: 120 }}>
        <InputLabel htmlFor="grouped-native-select">Grouping</InputLabel>
        <Select
          native
          defaultValue=""
          id="grouped-native-select"
          label="Grouping"
        >
          <option aria-label="None" value="" />
          <optgroup label="Category 1">
            <option value={1}>Option 1</option>
            <option value={2}>Option 2</option>
          </optgroup>
          <optgroup label="Category 2">
            <option value={3}>Option 3</option>
            <option value={4}>Option 4</option>
          </optgroup>
        </Select>
      </FormControl>
      <FormControl sx={{ m: 1, minWidth: 120 }}>
        <InputLabel htmlFor="grouped-select">Grouping</InputLabel>
        <Select defaultValue="" id="grouped-select" label="Grouping">
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          <ListSubheader>Category 1</ListSubheader>
          <MenuItem value={1}>Option 1</MenuItem>
          <MenuItem value={2}>Option 2</MenuItem>
          <ListSubheader>Category 2</ListSubheader>
          <MenuItem value={3}>Option 3</MenuItem>
          <MenuItem value={4}>Option 4</MenuItem>
        </Select>
      </FormControl>
    </div>
  );
};

const _MainTable: React.FC = () => {
  const formatter = new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  return (
    <TableContainer
      style={{ background: "transparent" }}
      sx={{ maxHeight: portalStore.portalHeight - 50, maxWidth: "100%" }}
    >
      <Table
        stickyHeader
        aria-label="sticky table"
        style={{ height: "300px", overflow: "scroll" }}
      >
        <TableHead>
          <TableRow style={{ fontWeight: "bold" }}>
            <TableCell>#</TableCell>
            <TableCell align="left">
              <b>Nickname (known-as)</b>
            </TableCell>
            <TableCell align="left">Gamer ID</TableCell>
            <TableCell align="left">Contact number</TableCell>
            <TableCell align="right">Wallet Credit (ZAR)</TableCell>
            <TableCell align="left">Premium Subscriber</TableCell>
            <TableCell align="left">FICA Verification</TableCell>
            <TableCell align="left">Joined</TableCell>
            <TableCell align="center">Action</TableCell>
            {/* <TableCell align="left">Status</TableCell>
            <TableCell align="left">Timestamp</TableCell>
            <TableCell align="left">Provider</TableCell> */}
          </TableRow>
        </TableHead>

        <tbody>
          {gamersStore.gamers.map((g, index) => (
            <tr key={g.uid} style={{ height: 60 }}>
              <td>{index + 1}</td>
              <TableCell align="left">{g.nickname}</TableCell>
              <TableCell align="left">{g.globalGamerId}</TableCell>
              <TableCell align="left">{g.phonenumber}</TableCell>
              <TableCell
                align="right"
                style={{
                  color: parseFloat(g.credit_balance) < 0 ? "tomato" : "black",
                }}
              >
                {parseFloat(g.credit_balance)
                  .toLocaleString("en-US", {
                    style: "currency",
                    currency: "ZAR",
                  })
                  .replace("ZAR", "")}
              </TableCell>
              <TableCell align="left">{"Yes | Play Store"}</TableCell>
              <TableCell align="left">{"Pending"}</TableCell>
              <TableCell align="left">
                {formatter.format(new Date(g.timestamp))}
              </TableCell>
              <TableCell align="center">
                <PlayerProfile uid={g.uid} />
              </TableCell>
            </tr>
          ))}
        </tbody>
      </Table>
    </TableContainer>
  );
};

const MainTable = observer(_MainTable);

export default PlayersSub;
